import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import useUiStore from '../store/uiStore';
import useAuthStore from '../store/authStore';
import { filterAccessibleItems } from '../utils/permissions';

const actions = [
  { label: 'ثبت درمان بیمارستانی', href: '/cow-treatment-sheets?openCreate=1', helper: 'ثبت سریع نسخه بیمارستانی گاو', permission: 'can_create_treatment' },
  { label: 'ثبت فحلی', href: '/estrus/new', helper: 'ورود رویداد فحلی', permission: 'can_register_service' },
  { label: 'ثبت تلقیح', href: '/repro/services', helper: 'ثبت سرویس / تلقیح', permission: 'can_register_service' },
  { label: 'ثبت آبستنی‌سنجی', href: '/repro/pregnancy-checks', helper: 'ثبت نتیجه PD', permission: 'can_register_service' },
  { label: 'باز کردن کارتابل باروری', href: '/repro/planner', helper: 'مرکز اقدام‌های باروری', permission: 'can_register_service' },
  { label: 'باز کردن میز سلامت و درمان', href: '/health/workbench', helper: 'صف‌های عملیاتی درمان', permission: 'can_create_treatment' },
];

function FastActionDialog() {
  const fastActionOpen = useUiStore((state) => state.fastActionOpen);
  const setFastActionOpen = useUiStore((state) => state.setFastActionOpen);
  const user = useAuthStore((state) => state.user);
  const visibleActions = useMemo(() => filterAccessibleItems(actions, user), [user]);

  useEffect(() => {
    const onKeyDown = (event) => {
      const targetTag = event.target?.tagName;
      const isInputLike = ['INPUT', 'TEXTAREA', 'SELECT'].includes(targetTag) || event.target?.isContentEditable;
      if (!isInputLike && event.shiftKey && event.key.toLowerCase() === 'a') {
        event.preventDefault();
        setFastActionOpen(true);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [setFastActionOpen]);

  return (
    <Modal isOpen={fastActionOpen} onClose={() => setFastActionOpen(false)} title="اقدام سریع" size="lg">
      <div className="grid gap-3 md:grid-cols-2">
        {visibleActions.map((action) => (
          <Link
            key={action.href}
            to={action.href}
            onClick={() => setFastActionOpen(false)}
            className="rounded-2xl border border-slate-200 bg-white px-4 py-4 transition hover:border-primary-200 hover:bg-primary-50"
          >
            <div className="text-sm font-semibold text-slate-900">{action.label}</div>
            <div className="mt-1 text-xs text-slate-500">{action.helper}</div>
          </Link>
        ))}
        {!visibleActions.length ? (
          <div className="rounded-2xl border border-dashed border-slate-300 px-4 py-8 text-center text-sm text-slate-500 md:col-span-2">
            هیچ اقدام سریعی برای سطح دسترسی فعلی شما فعال نیست.
          </div>
        ) : null}
      </div>
    </Modal>
  );
}

export default FastActionDialog;
